var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8486 19.8237C22.8198 20.2352 21.5697 19.9018 21.0554 19.0789L12.5 5.39605L3.94462 19.0789C3.43026 19.9018 2.18016 20.2352 1.15144 19.8237C0.122709 19.4122 -0.293993 18.4122 0.220371 17.5892L10.6379 0.921912C10.9895 0.354183 11.7122 0 12.5 0C13.2878 0 14.0105 0.354183 14.3621 0.921912L24.7796 17.5892C25.294 18.4122 24.8773 19.4122 23.8486 19.8237Z",
    fill: "#FFF7D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow4);
export default __webpack_public_path__ + "static/media/arrow4.9c96816ba1f54f92dd4d25abaaa5cd20.svg";
export { ForwardRef as ReactComponent };